import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-bn-success-notice',
  templateUrl: './bn-success-notice.component.html',
  styleUrls: ['./bn-success-notice.component.scss']
})
export class BnSuccessNoticeComponent implements OnInit {
  @Input() title;
  @Input() message;
  hideAlert: boolean;
  isAcmic:boolean;

  constructor(
    private acmicService:AcmicService
  ) {
    this.hideAlert = false;
    this.title = 'You’re all set';
    this.message = 'Your policy is paid in full, no payment is due at this time.';
   }

  onClose() {
    this.hideAlert = true;
  }
  ngOnInit(): void {
    this.isAcmic=this.acmicService.isACMIC();
  }

}
